import BackArrow from "@src/assets/icons/BackArrow";
import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { BackButtonTextWrapper, BackButtonWrapper } from "./style";

interface HeaderBackButtonType {
  title: string;
}

const HeaderBackButton: FC<HeaderBackButtonType> = ({ title }) => {
  const navigate = useNavigate();
  return (
    <BackButtonWrapper onClick={() => navigate(-1)}>
      <BackArrow />
      <BackButtonTextWrapper>{title}</BackButtonTextWrapper>
    </BackButtonWrapper>
  );
};

export default HeaderBackButton;
